import apiClient from '../axios'

export default async function getMenuData() {
  return [
    {
      title: 'Dashboard',
      key: 'dashboard',
      icon: 'fe fe-briefcase',
      url: '/dashboard',
    },
    {
      title: 'Merchants',
      key: 'merchants',
      icon: 'fe fe-users',
      url: '/merchants',
    },
    {
      title: 'Transaction',
      key: 'transactions',
      icon: 'fe fe-dollar-sign',
      url: '/transaction',
    },
    {
      title: 'Sub-Agents',
      key: 'subAgents',
      icon: 'fe fe-users',
      url: '/sub-agents',
    },
    {
      title: 'Payout History',
      key: 'payoutHistory',
      icon: 'fe fe-list',
      url: '/payout-history',
    },
  ]
}

export async function getMenuItemCount() {
  return apiClient
    .get(`/businesses/count`)
    .then(response => {
      return response?.data?.data ?? {}
    })
    .catch(err => console.log(err))
}
